import { render, staticRenderFns } from "./show.vue?vue&type=template&id=11a4bdcd&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a4bdcd')) {
      api.createRecord('11a4bdcd', component.options)
    } else {
      api.reload('11a4bdcd', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=11a4bdcd&", function () {
      api.rerender('11a4bdcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/annual-return/show.vue"
export default component.exports